export const tokens = {
    action: {
        gap: 10,
        padding: 4,
        radius: 6,
    },
    content: {
        gap: 10,
    },
    thumbnail: {
        size: 30,
        radius: 4,
    },
    name: {
        size: 14,
    },
    supply: {
        size: 12,
    },
};
